import { Card, Image, Text, Grid, Stack, } from '@mantine/core';
import { motion } from "motion/react"





export const LoginWrapper = ({ children, animate = false }: { children?: React.ReactNode, animate: boolean }) => {

        return (
        <Grid>
            <Grid.Col span={{base: 6, md: 6, lg: 8}} visibleFrom="md">
                {animate ? (
                    <motion.div initial={{ opacity: 0, x: -40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1, ease: 'easeIn' }}>
                        <Stack justify="center" align="center" h='100vh' w='100%'>
                            <Image src="/logo_talk2me.png" alt="CircleBe Logo" mah={200} maw={400} fit="contain" />
                        </Stack>
                    </motion.div>
                ) : (
                    <Stack justify="center" align="center" h='100vh' w='100%'>
                        <Image src="/logo_talk2me.png" alt="CircleBe Logo" mah={200} maw={400} fit="contain" />
                    </Stack>
                )}

            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 4 }} bg='white'>
                <Stack justify="center"  h='100vh' w='100%' p={{ base: 'md', md: 'xl' }}>
                    <motion.div initial={{ opacity: 0, x: 0 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 1, ease: 'easeIn' }}>
                        {children}
                    </motion.div>
                </Stack>
            </Grid.Col>
        </Grid>
        )



}